import { useTags } from '@/hooks/useAuctions';
import { useFiltersStore } from '@/lib/filtersStore';
import { haptic } from '@/lib/telegram';
import clsx from 'clsx';
import styles from './TagChips.module.css';

export const TagChips = () => {
  const { data: tags } = useTags();
  const selected = useFiltersStore((s) => s.selectedTags);
  const toggleTag = useFiltersStore((s) => s.toggleTag);
  const clearTags = useFiltersStore((s) => s.clearTags);

  const handleToggle = (slug: string) => {
    haptic.selection();
    toggleTag(slug);
  };

  return (
    <div className={styles.scroll}>
      <div className={styles.track}>
        <button
          onClick={() => { haptic.selection(); clearTags(); }}
          className={clsx(styles.chip, selected.length === 0 && styles.chipActive)}
        >
          Всё
        </button>
        {tags?.map((tag) => {
          const isActive = selected.includes(tag.slug);
          return (
            <button
              key={tag.id}
              onClick={() => handleToggle(tag.slug)}
              className={clsx(styles.chip, isActive && styles.chipActive)}
            >
              {tag.name_ru}
            </button>
          );
        })}
      </div>
    </div>
  );
};